
export default {
  name: "cal-header-with-progress",
  props: {
    "isValid":  {
      "type": Boolean,
      default: false
    },
    headerTitle:{
      type: String,
      required: true
    },
    hideProgress: {
      type: Boolean,
      default: false,
    },
  },
};
